<template>
  <div>
    <div class="tableau-wrapper row">
      <div
        class="tableau-body"
        :class="{ 'no-type': !showType }"
        ref="tableauBody"
      >
        <loading v-if="this.loading" />
        <tableau
          v-if="!this.loading && this.typeDonnees && this.tableauData"
          ref="tableau"
          :type-donnees="typeDonnees"
          :tableau-data="tableauData"
        />
      </div>
      <div class="tableau-tab">
        <tableauTitre
          v-if="this.tableauData"
          :tableauDetails="ongletsList"
          @addOnglet="handleAddOnglet"
          @changeOngletTitre="handleChangeOngletTitre"
          @changeOnglet="handleChangeOnglet"
          @supprimer="handleDeleteOnglet"
        ></tableauTitre>
      </div>
    </div>
  </div>
</template>
<script>
import toolBar from '../../components/tableauSurface/toolbar'
import tableau from '../../components/tableau/tableau'
import tableauTitre from '../../components/tableau/tableauTitre'
import loading from '../../components/loading'
import { mapActions, mapGetters } from 'vuex'
import { EventBus, events } from '../../eventBus'
export default {
  props: {
    modeVue: {
      type: Boolean
    }
  },
  components: {
    toolBar,
    tableau,
    tableauTitre,
    loading
  },
  data () {
    return {
      tableauData: {},
      ongletsList: [],
      shouldSave: false,
      firstLoad: true
    }
  },
  watch: {
    async currentOnglet (newValue) {
      if (newValue == null) {
        return
      }

      if (this.firstLoad) {
        this.firstLoad = false
        return
      }
      this.setLoading(true)
      this.setEntityId(parseInt(newValue))
      this.tableauData = await this.getTableauData(newValue)
      this.setLoading(false)
    },
    async notifLink (newValue) { // link from notification set if from notification
      if (this.currentOnglet !== newValue.entite && newValue.entite != null) {
        this.setLoading(true)
        this.setIsLoadedComments(false) // reloading comment
        await this.switchTableau(newValue.projet.id, newValue.entite)
        this.setLoading(false)
      }
      this.setIsFromNotif(true)
    }
  },
  mounted () {
    EventBus.$on(events.HAS_MODIFICATION, this.onHasModification)
  },
  beforeDestroy () {
    EventBus.$off(events.HAS_MODIFICATION, this.onHasModification)
  },
  async created () {
    try {
      const idProject = this.$route.params.idProject
      this.setLoading(true)
      this.setTypeModule('tableau_surface')
      this.setCurrentOnglet(null)
      await this.getTypeDonnees()
      await this.getListOnglet(idProject)
      this.ongletsList = this.listOnglet()

      if (this.notifLink) {
        this.setIsLoadedComments(false) // reloading comment
        await this.switchTableau(this.notifLink.projet.id, this.notifLink.entite)
        this.setIsLoadedEntityId(true)
        this.setIsFromNotif(true)
      } else if (localStorage.getItem('last_tds_tab') != null || '' + localStorage.getItem('last_tds_tab') !== 'null') {
        this.setIsLoadedEntityId(false)
        this.setCurrentOnglet(localStorage.getItem('last_tds_tab'))
        await this.setEntityId(parseInt(localStorage.getItem('last_tds_tab'))) // entity id for comment
        localStorage.removeItem('last_tds_tab')
        this.setIsLoadedEntityId(true)
      } else if (this.ongletsList[0]) {
        this.setIsLoadedEntityId(false)
        this.setCurrentOnglet(this.ongletsList[0].id)
        await this.setEntityId(parseInt(this.ongletsList[0].id)) // entity id for comment
        this.setIsLoadedEntityId(true)
      } else if (!this.ongletsList[0]) {
        let dataNewTableau = {
          nom: 'Tableau ' + parseInt(this.ongletsList.length + 1, 10),
          rang: this.ongletsList.length + 1,
          etat: 1,
          projet: parseInt(this.currentProject, 10),
          descriptions: []
        }
        await this.addOnglet(dataNewTableau)
        this.ongletsList = this.listOnglet()
        this.setIsLoadedEntityId(false)
        this.setCurrentOnglet(this.ongletsList[0].id)
        await this.setEntityId(this.ongletsList[0].id) // entity id for comment
        this.setIsLoadedEntityId(true)
      }
      this.tableauData = await this.getTableauData(this.currentOnglet)
    } catch (e) {
    } finally {
      this.setLoading(false)
    }
  },
  computed: {
    ...mapGetters(['notifLink', 'typeDonnees', 'currentOnglet', 'currentProject', 'loading', 'isFromNotif', 'notifLink', 'showType'])
  },
  methods: {
    ...mapGetters(['listOnglet', 'typeModule', 'entityId', 'ficheTableauData']),
    ...mapActions(['setLinkComment', 'setMessage', 'setPending', 'setIsLoadedComments', 'setIsLoadedEntityId', 'setIsFromNotif', 'setEntityId', 'setCurrentOngletLoaded', 'setTypeModule', 'modificationAttributOnglet', 'getTypeDonnees', 'getListOnglet', 'setCurrentOnglet', 'getTableauData', 'setLoading', 'addOnglet', 'deleteOnglet', 'setListOnglet']),
    onHasModification (val) {
      this.shouldSave = val
    },
    async switchTableau (idProjet, idOnglet) {
      // this.setEntityId(parseInt(idOnglet))
      // this.tableauData = await this.getTableauData(idOnglet)
      this.setCurrentOnglet(idOnglet)
      await this.getListOnglet(idProjet)
      this.ongletsList = this.listOnglet()
      this.setLinkComment(null)
    },
    async handleAddOnglet () {
      try {
        this.setPending(true)
        let dataNewTableau = {
          nom: 'Tableau ' + parseInt(this.ongletsList.length + 1, 10),
          rang: this.ongletsList.length + 1,
          etat: 1,
          projet: parseInt(this.currentProject, 10),
          descriptions: []
        }
        await this.addOnglet(dataNewTableau)
        this.ongletsList = this.listOnglet()
      } catch (e) {
        this.setMessage('Une erreur est survenue')
        // this.$toaster.error('Une erreur est survenue')
      } finally {
        this.setPending(false)
      }
    },
    async handleChangeOngletTitre (event, ongletData) {
      let titre = event.target.innerText
      let attrs = {
        id: ongletData.id,
        nom: titre,
        etat: ongletData.etat,
        projet: parseInt(this.currentProject, 10),
        rang: ongletData.rang
      }
      if (titre !== ongletData.nom && titre !== '') {
        attrs.nom = titre
        await this.modificationAttributOnglet(attrs)
        await this.getListOnglet(parseInt(this.currentProject, 10))
      }
      if (titre === '') {
        event.target.innerText = attrs.nom
      }
    },
    async handleChangeOnglet (id) {
      if (this.shouldSave) {
        await this.$refs['tableau'].handleSave()
      }
      this.setCurrentOnglet(id)
      this.setEntityId(parseInt(id))
      EventBus.$emit(events.REFRESH_NOTIFICATION)
    },
    handleDeleteOnglet (id) {
      this.$bvModal.msgBoxConfirm(`Voulez-vous vraiment supprimer cet onglet ?`, {
        modalClass: 'base-modal ',
        title: "Suppression d'onglet",
        buttonSize: 'sm',
        headerClass: 'bg-danger',
        okVariant: 'outline-danger',
        okTitle: 'OUI',
        cancelVariant: 'outline-primary',
        cancelTitle: 'NON',
        footerClass: 'p-2',
        hideHeaderClose: true
      })
        .then(async value => {
          if (value) {
            const res = await this.deleteOnglet(id)
            this.ongletsList = this.listOnglet()
            this.setMessage(res)
            // this.$toaster.info(res, { timeout: 3000 })
          }
        })
    }

  }

}
</script>
<style lang="scss">
.tableau-wrapper {
  height: calc(100vh - 56px);
}
.tableau-body {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 120px);
  /*height: calc(100vh - 93px);*/
  padding-top: 100px;
  // overflow-x: auto;
  .jexcel_content {
    padding-top: 16px;
  }
  &.no-type {
    .jexcel_content {
      padding-top: 0;
    }
  }
  .title-and-search {
    position: fixed;
    background-color: #fff;
    top: 56px;
    z-index: 1001;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
  }
}
.disabled-action {
  position: relative;
  cursor: not-allowed;
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: transparent;
    z-index: 100;
  }
  button {
    color: #6c757d;
    border-color: #6c757d;
    &.active {
      background-color: #6c757d !important;
    }
  }
}
#tableau {
  .button-box {
    padding-right: 185px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pageTableau/index.vue